import { User } from 'firebase/auth'

export const bootClack = async (user: User) => {
  // @ts-expect-error ClackChatWidget is not defined
  if (window.ClackChatWidget) {
    return
  }
  const script = document.createElement('script')
  script.src = 'https://widget.clack.jp/script.js'
  script.defer = true
  script.onload = () => {
    // @ts-expect-error ClackChatWidget is not defined
    if (window.ClackChatWidget) {
      // @ts-expect-error ClackChatWidget is not defined
      window.ClackChatWidget.boot({
        teamId: 'T019FN9NCE6',
        customer: {
          id: user.uid,
          name: user.displayName || 'anonymous',
          email: user.email || 'anonymous'
        },
        support: {
          name: 'Nitte サポート',
          icon_url: 'https://nitte.app/apple-touch-icon.png'
        }
      })
    } else {
      console.error('ClackChatWidget が見つかりませんでした')
    }
  }
  document.body.appendChild(script)
}
